import { useRef } from 'react';

import { useDropZone, useFileDialog } from '@realadvisor/hooks';

type UseImageFilePickerOptions = {
  onFile: (file: File) => void;
};

/**
 * Provides one-image selection through either the native file dialog or a
 * drop target. Keeping both entry points together ensures image inputs accept
 * the same file type and always forward just the first selected file.
 */
export const useImageFilePicker = ({ onFile }: UseImageFilePickerOptions) => {
  const dropZoneRef = useRef<HTMLButtonElement>(null);

  const openFileDialog = useFileDialog({
    accept: 'image/*',
    multiple: false,
    onChange: ([file]) => {
      if (file) {
        onFile(file);
      }
    },
  });

  const dragOver = useDropZone({
    targetRef: dropZoneRef,
    accept: 'image/*',
    onDrop: ([file]) => {
      if (file) {
        onFile(file);
      }
    },
  });

  return { dropZoneRef, dragOver, openFileDialog };
};
